import { ContactConstants } from '../_constants/contact-constants';
export class UserPropertyResultDto {
  communityName: string;
  communityId: number;
  customerId: string;
  propertyAddress: string;
  isCurrentOwner: boolean;
  isSelfManagedCommunity: boolean;
  ownerId: number;
  propertyId: number;
  managementCompanyId: number;
  managementCompanyName: string;
  ownerName: string;

  private _contactPhoneText: string;
  private _contactPhoneNumber: string;

  get displayName(): string {
    return `${this.propertyAddress}\n${this.communityName}\n${this.customerId}`;
  }

  get selectName(): string {
    return `${this.propertyAddress}<br>${this.communityName}<br>${this.customerId}`;
  }

  get headerText(): string {
    return `${this.propertyAddress}\n${this.communityName}`;
  }

  public get contactPhoneText(): string {
    return this._contactPhoneText;
  }

  public set contactPhoneText(v: string) {
    if (!!v) {
      this._contactPhoneText = v;
    } else {
      this._contactPhoneText = ContactConstants.contactUsPhoneDisplayText;
    }
  }

  public get contactPhoneNumber(): string {
    return this._contactPhoneNumber;
  }

  public set contactPhoneNumber(v: string) {
    if (!!v) {
      this._contactPhoneNumber = v;
    } else {
      this._contactPhoneNumber = ContactConstants.contactUsPhone;
    }
  }

  public get uniqueId(): string {
    return `${this.communityId}-${this.customerId}`;
  }
}
